
import { usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({

    setup()
    {
        const router = useRouter();
        const copyrightYear = (new Date()).getFullYear();

        function onCreateNewPatient(e : Event)
        {
            e.preventDefault();

            // Clear stores so we start with a fresh patient
            usePatientStore().$reset();
            useRequestDataStore().deselectDrug();

            // Navigate to the app
            router.push("/app");
        }

        function onLoadInterpretation(e : Event)
        {
            e.preventDefault();
        }

        function onShowPendingRequests(e : Event)
        {
            e.preventDefault();
        }

        return {
            copyrightYear,
            onCreateNewPatient,
            onLoadInterpretation,
            onShowPendingRequests,
        };
    },
})
